import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ChangePasswordViewModel } from '../../models/ChangePasswordViewModel'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import IconCheckMarkHeader from '../../globals/images/icon-checkmark-header.svg'
import ReactDOM from 'react-dom'

export default class ChangePasswordConfirmation extends Component  {

    get config() {
        return this.props.config || {}
    }
    get logInUrl() {
        return this.config.logInUrl || process.env.REACT_APP_LOG_IN 
    }
    get changePasswordViewModel() {
        return this.props.config.changePasswordViewModel || {}
    }
    componentDidMount() {
        ReactDOM.findDOMNode( this.refs.confirmationCard ).focus() 
    }
    render() {
        const title = 'Password Updated'
        const message =`You have successfully updated the password for ${ this.changePasswordViewModel.email }.`
        const ariaMessage = title +'. '+ message
        return (
            <>
                <main className="c-main forgot-password">
                    <div className="os-container--max-width">
                        <div className="c-form-card"  ref={ 'confirmationCard' } aria-label={ ariaMessage } tabIndex={ 0 }>
                            <div className="c-form-card__container">
                                <h1 className="o-heading-alpha mb-8 pb-0 pl-9" tabIndex={ 0 } autoFocus={ true }>
                                    <img src={ IconCheckMarkHeader } alt="Confirmation" className="c-svg-header-icon"/>
                                    { title } 
                                </h1>
                                <div className="c-form-confirmation-message"><p data-testid="main-message" tabIndex={ 0 }>{ message }<a href={ UrlBuilder( { url: this.logInUrl, buildURL: true } ) } className="c-link"><span className="sign-in-option">Sign In</span></a></p></div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

ChangePasswordConfirmation.propTypes = {
    config: PropTypes.shape( {
        logInUrl: PropTypes.string,
        changePasswordViewModel: PropTypes.instanceOf( ChangePasswordViewModel )
    } )
}